"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _eventemitter = require("eventemitter2");

var _Client = _interopRequireDefault(require("./Client"));

var _Payloads = require("./helpers/Payloads");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * An Asset is a single asset stored on the Community Platform.
 * Nodes within an asset will be defined when adding an annotation.
 */
var Asset = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Asset, _EventEmitter);

  var _super = _createSuper(Asset);

  /**
   * Initializes with asset urn.
   * @param   {String}  id  Asset urn
   */
  function Asset(id) {
    var _this;

    _classCallCheck(this, Asset);

    // Setup EventEmitter2
    _this = _super.call(this);
    _this.id = id;
    _this.etag = null;
    _this.pollingTimer = null;
    return _this;
  }
  /**
   * Helper returns legacy path root if config is in legacy mode.
   *
   * @return  {string}  legacy path root
   */


  _createClass(Asset, [{
    key: "getPathRoot",
    value: function getPathRoot() {
      return _Client["default"].instance.isACP ? '' : "assets/".concat(this.id);
    }
    /**
     * Performs an API get for the current asset id, and provides a collection of annotations
     * for the asset.  The can be affected by the Client.instance.type which
     * filters the returning set based on this value.  Replies vs Comments are grouped.
     *
     * @param   {bool}  useEtag  If true, respects etag handling to support polling requests
     * @deprecated ACP handling does not support permissions or disabled authorizations
     * @return  {promise}  The promise resolved as an AnnotationCollection model object
     */

  }, {
    key: "get",
    value: function get(useEtag) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var type = _Client["default"].instance.commentType;

        var path = _this2.getPathRoot();

        if (!_Client["default"].instance.isACP) {
          path += '/annots/';
        }

        if (type !== null && type !== undefined) {
          path += "?status=".concat(type);
        }

        _Client["default"].instance.request(_this2.id, 'asset.get', path, 'GET', null, useEtag ? {
          'If-None-Match': _this2.etag
        } : {}).then(function (annotationsObj) {
          if (!annotationsObj || !annotationsObj.retryAfter) {
            _this2.disableUpdates();
          } // dont resolve or reject if current asset no longer matches


          if (_this2.id !== _Client["default"].instance.assetId) {
            return;
          }

          if (annotationsObj && annotationsObj.annotations) {
            _this2.etag = annotationsObj.etag ? annotationsObj.etag : null; // Store the replies

            var allReplies = annotationsObj.annotations.filter(function (annotation) {
              return annotation.motivation === _Payloads.MOTIVATIONS.REPLY;
            }); // Create a new collection without replies

            var noReplies = annotationsObj.annotations.filter(function (annotation) {
              return annotation.motivation !== _Payloads.MOTIVATIONS.REPLY;
            }); // Map all replies to their respective parent

            var groupedReplies = noReplies.map(function (annotation) {
              var annotationReplies = allReplies.filter(function (reply) {
                return (// Check for correlation between reply and originating comment.
                  reply.target.source.includes(annotation.id)
                );
              });

              if (annotationReplies) {
                annotation.replies = annotationReplies;
              }

              return annotation;
            }); // Setup update timer

            if (_Client["default"].instance.pollForUpdates && !_this2.pollingTimer && (0, _Payloads.isDefined)(annotationsObj.retryAfter)) {
              _this2.pollingInterval = parseInt(annotationsObj.retryAfter, 10) * 1000;
              _this2.pollingTimer = setInterval(_this2.checkForUpdates.bind(_this2), _this2.pollingInterval);
            } // Create a new annotationsCollection object to return


            var annotationsCollection = Object.assign({}, annotationsObj); // Set the annotations to grouped replies

            annotationsCollection.annotations = groupedReplies; // Return the grouped replies

            resolve(annotationsCollection);
          } else if (_Client["default"].instance.pollForUpdates) {
            // Set/Reset update timer.
            var newPollingInterval = parseInt(annotationsObj.retryAfter, 10) * 1000;

            if (_this2.pollingInterval !== newPollingInterval) {
              _this2.pollingInterval = newPollingInterval;

              if (_this2.pollingTimer) {
                clearInterval(_this2.pollingTimer);
                _this2.pollingTimer = null;
              }
            }

            if (!_this2.pollingTimer && _this2.pollingInterval !== undefined) {
              _this2.pollingTimer = setInterval(_this2.checkForUpdates.bind(_this2), _this2.pollingInterval);
            }
          } else {
            // For testing purposes.
            resolve(null);
          }
        })["catch"](function (err) {
          _this2.disableUpdates();

          reject(err);
        });
      });
    }
    /**
     * Check for new comments for asset using etag handling.  (Will also re-enable polling if configured)
     * @yields Emits an 'update' event containing an AnnotationsCollection model object
     * @return {undefined}
     */

  }, {
    key: "checkForUpdates",
    value: function checkForUpdates() {
      var _this3 = this;

      this.get(true).then(function (annotations) {
        if (annotations) {
          _this3.emit('update', annotations);
        }
      });
    }
    /**
     * Turn off polling for comments.
     *
     * @returns {undefined}
     */

  }, {
    key: "disableUpdates",
    value: function disableUpdates() {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
    /**
     * Performs an API get for all resolved comments for this asset.
     *
     * @return  {promise}  The promise resolved as an AnnotationCollection model object
     */

  }, {
    key: "getResolved",
    value: function getResolved() {
      var path = this.getPathRoot();

      if (!_Client["default"].instance.isACP) {
        path += '/annots';
      } // By default, only 'open' statuses are returned.  You can also specify 'status=open,resolved'.


      path += "/?status=".concat(_Payloads.STATUS.RESOLVED);
      return _Client["default"].instance.request(this.id, 'asset.getResolved', path, 'GET', null, {});
    }
    /**
     * Creates a fresh comment for the given asset.
     *
     * @param   {string}  commentText      The comment text
     * @param   {string}  nodeId           node id (optional)
     * @param   {json}  coordinates        json payload for noteX,Y and sectionId (optional)
     * @param   {json[]}  mentionUserList  The array of mentions (optional)
     *
     * @return  {promise}                   [return description]
     */

  }, {
    key: "comment",
    value: function comment(commentText, nodeId, coordinates, mentionUserList) {
      try {
        var payload = (0, _Payloads.getCommentPayload)(this.id, commentText, nodeId, coordinates, mentionUserList, _Payloads.MOTIVATIONS.COMMENT);
        var path = this.getPathRoot();

        if (!_Client["default"].instance.isACP) {
          path += '/annots/';
        }

        return _Client["default"].instance.request(this.id, 'asset.comment', path, 'POST', payload, {});
      } catch (err) {
        console.log(err);
        return Promise.reject(err);
      }
    }
    /**
     * Method used to batch remap comment change
     *
     * @param   {object}  remapData      Object containing new target objects for comments
     * example: remapData = {
     *  "/assets/urn:aaid:ccx:US:833d5e43-cfbc-4b4e-80d1-31376c94dfd2/annots/2df91930-6cdf-4907-bb07-f1515f1e5893": {
     *    "selector": {
     *      "node": {
     *        "index": 0,
     *        "id": 1,
     *        "clientAdjustedIndexToId": true
     *      },
     *      "noteX": 200,
     *      "subtype": "note",
     *      "noteY": 200,
     *      "type": "AdobeAnnoSelector",
     *      "strokeColor": "#B80000"
     *    },
     *    "source": "/assets/urn:aaid:ccx:US:833d5e43-cfbc-4b4e-80d1-31376c94dfd2",
     *    "state": "unknown"
     *  }
     * }
     *
     * @return  {promise}                   [return description]
     */

  }, {
    key: "remap",
    value: function remap(remapData) {
      var payload = {
        requests: []
      };

      if (remapData && Object.keys(remapData).length) {
        Object.keys(remapData).forEach(function (key) {
          var content = {
            target: remapData[key]
          };
          payload.requests.push({
            method: 'put',
            headers: {
              'X-Feature-Override': 'NoNotifications,NoModificationDateUpdate',
              'If-Match': '*'
            },
            body: {
              'x-request-id': '',
              id: key.split('/').pop(),
              content: (0, _Payloads.updateCoordinates)(content, undefined, true)
            }
          });
        });
        var path = "sync/collections/".concat(this.id, ":aec/entities/");
        return _Client["default"].instance.request(this.id, 'asset.batchRemap', path, 'POST', payload, {});
      } // eslint-disable-next-line prefer-promise-reject-errors


      return Promise.reject('Invalid remap data');
    }
  }]);

  return Asset;
}(_eventemitter.EventEmitter2);

var _default = Asset;
exports["default"] = _default;